module.exports = __webpack_public_path__ + "static/img/share3.55c1900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share3.png
// module id = ynn0
// module chunks = 0